<div class="relative">
    <div
        class="mx-4 my-2 grid grid-cols-3 gap-4"
        [attr.aria-label]="'CART_PAYMENT_METHOD' | translate"
        role="radiogroup">
        <div
            class="m-0"
            *ngFor="let method of methods; let last = last"
            [ngClass]="{ last: last }"
            [attr.aria-label]="method.displayName + ', ' + ('ACCESSIBILITY_TOGGLE_ELEMENT' | translate)"
            (click)="select(method)"
            role="radio"
            attr.aria-checked="{{ isSelected(method) }}"
            tabindex="0">
            <div class="m-0 box-border p-0">
                <div
                    class="z-1 relative min-w-full rounded-lg border border-solid bg-white font-semibold shadow-md"
                    [ngClass]="{
                        'border-2 border-secondary p-0 dark:border-contrast-yellow': isSelected(method),
                        'method-container': !isSelected(method)
                    }">
                    <div class="flex w-full">
                        <div
                            class="flex-column align-center flex table-cell h-auto w-full justify-center align-middle text-base leading-none">
                            <div class="float-left m-0 mt-2 h-9 w-full leading-none">
                                <img
                                    class="h-7 dark:filter-yellow"
                                    src="{{ env.PAYMENT_PORTAL_URL + method?.imageUrl }}"
                                    alt="{{ method.displayName }}"
                                    aria-hidden="true" />
                            </div>

                            <div class="align-center truncate px-2 leading-10">
                                <span>{{ method.displayName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
